<template>
  <div class="container mscontainer">
    <follow v-if="minipath" :path="minipath"></follow>
    <div class="result_list">
      <div class="header">
        <div class="tit">
          <!--<img :src="actImgPath"/>-->
          <img src="../../../static/images/38act/msactimg1.png?v=1" />
        </div>
        <div class="share">
          <div class="btn" @click="share">分享给好友</div>
        </div>
        <div class="rule">
          <div @click="ruleFn" class="btn f11">活动规则</div>
        </div>
      </div>
      <van-sticky>
        <div class="navlist">
          <van-tabs
            :ellipsis="false"
            @click="handleTime"
            background="transparent"
            line-height="0px"
          >
            <van-tab :title="String(-1)" title-class="li">
              <template #title>
                <img src="../../../static/images/38act/mstoday1.png?v=1" />
              </template>
            </van-tab>
            <van-tab
              :key="index"
              :title="String(index)"
              :title-class="{ qgz: actindex == index, li: true }"
              v-for="(item, index) in beginTimeList"
              v-if="beginTimeList.length > 1"
            >
              <template #title>
                <div class="time">{{ item.time }}</div>
                <div class="btn" v-if="curindex[index] == index">抢购中</div>
                <div class="btn" v-else-if="curindex[index] == -1">
                  即将开始
                </div>
                <div class="btn" v-else-if="curindex[index] == -2">
                  明日抢购
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
      </van-sticky>
      <div class="list" v-if="list && list.length > 0">
        <div class="itembg" v-for="(item, index) in list" :key="item.limitid">
          <!--          <div class="tag" v-if="item.remark">-->
          <!--            <div class="msg">-->
          <!--              <img src="../../../static/images/38act/msfire.png">{{item.remark}}-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="item">
            <!--            <div :class="{'disabled':item.actstatus == 2}"></div>-->
            <!--<div class="ck">-->
            <!--<van-radio :name="item.skuid" checked-color="#F20023"></van-radio>-->
            <!--</div>-->
            <div class="proitem">
              <div @click="productFn(item)" class="img">
                <img v-lazy="item.img_path" />
                <img
                  src="/static/images/shouqing.png"
                  class="soldout"
                  v-if="item.islimit == 2"
                />
                <img
                  src="/static/images/soldout.png"
                  class="soldout"
                  v-else-if="item.issale == 0"
                />
              </div>
              <div class="con">
                <div class="tit" @click="productFn(item)">
                  {{ item.name }}
                </div>
                <!--                  <div class="supplement">含（70±5）%酒精</div>-->
                <div class="totalinv">共{{ item.stocknum || 0 }}份</div>
                <!--<div class="spec">-->
                <!--<div class="spec_con" @click="openSku(item, index)">{{item.spec}}-->
                <!--<van-icon name="arrow-down"/>-->
                <!--</div>-->
                <!--</div>-->
                <div class="priceAndnum">
                  <div class="pricebox">
                    <div class="price" @click="productFn(item)">
                      <span class="positive"
                        >¥{{ parseFloat(item.sales_price).toFixed(2) }}</span
                      >
                      <!--                      <span class="fh">元</span>-->
                    </div>
                    <div class="price gray" @click="productFn(item)">
                      <span class="positive"
                        >¥{{ parseFloat(item.cost_price).toFixed(2) }}</span
                      >
                      <!--                      <span class="fh">元</span>-->
                    </div>
                  </div>
                  <!--<div class="num">-->
                  <!--<van-stepper v-model="item.num"/>-->
                  <!--</div>-->
                  <!--                  <div class="progress" v-if="curindex[actindex] == actindex">-->
                  <!--                    <van-progress :percentage="item.sales_rate" color="#F9321A" track-color="#D9D9D9"/>-->
                  <!--                    <div class="num">{{item.sales_rate == 100?'100%':item.sales_ratename}}</div>-->
                  <!--                    <div class="bought">已抢{{item.sales_num}}件</div>-->
                  <!--                  </div>-->
                  <!--                  <div class="progress" v-else>-->
                  <!--                    <van-progress :percentage="0" color="#F9321A" track-color="#D9D9D9"/>-->
                  <!--                    <div class="num">0%</div>-->
                  <!--&lt;!&ndash;                    <div class="bought">已抢{{item.sales_num}}件</div>&ndash;&gt;-->
                  <!--                  </div>-->
                  <van-count-down
                    :time="item.time"
                    @finish="finish(item, index)"
                  >
                    <template #default="timeData">
                      <span v-if="item.actstatus == 1" class="text"
                        >距开始</span
                      >
                      <span v-else class="text">距结束</span>
                      <span class="time">{{
                        timeData.days * 24 + timeData.hours < 10
                          ? '0' + timeData.hours
                          : timeData.days * 24 + timeData.hours
                      }}</span>
                      <span class="text colon">:</span>
                      <span class="time">{{
                        timeData.minutes >= 10
                          ? timeData.minutes
                          : '0' + timeData.minutes
                      }}</span>
                      <span class="text colon">:</span>
                      <span class="time">{{
                        timeData.seconds >= 10
                          ? timeData.seconds
                          : '0' + timeData.seconds
                      }}</span>
                    </template>
                  </van-count-down>
                </div>
                <div
                  class="dialog"
                  v-if="item.actstatus == 1"
                  @click="productFn(item)"
                >
                  即将开始
                </div>
                <div class="dialog1" v-else-if="item.actstatus == 2">
                  已抢完
                </div>
                <div class="dialog" v-else @click="productFn(item)">去抢购</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nodata" v-else>
        暂无秒杀商品，看看其他的吧
      </div>
    </div>
    <van-overlay :show="showshare" z-index="99"> </van-overlay>
    <div class="sharecontainer" v-if="showshare === true">
      <img src="../../assets/images/sharemc.png" />
      <van-button
        round
        plain
        type="danger"
        class="know"
        @click="showshare = false"
        >我知道了</van-button
      >
    </div>
    <div class="floatBtn_new">
      <img
        v-if="isnewpersontask"
        @click="newpersontask"
        src="/static/images/new-person/newpersontask@2x.png"
      />
      <img src="/static/images/homebtn1.png" class="home" @click="homeClick" />
    </div>
  </div>
</template>

<script>
import {
  isWeixin,
  fenxiang,
  basepath,
  Base64,
  isApp,
  goMini,
  wxAjaxData,
  getQueryString,
  exclusiveidFn,
  pointParams,
  dateStrFn
} from '../../assets/common/js/config'
import { Tag, Overlay, Progress, Sticky } from 'vant'
import follow from '../common/follow'
import wx from 'weixin-js-sdk'

export default {
  name: 'community-promote-act',
  components: {
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    [Progress.name]: Progress,
    [Sticky.name]: Sticky,
    follow
  },
  computed: {
    curindex() {
      var i = []
      console.log(this.beginTimeList)
      this.beginTimeList.forEach((item, index) => {
        var timestamp = this.parserDate(item.begintime) / 1000,
          timestamp1 = ''
        if (index < this.beginTimeList.length) {
          timestamp1 = this.parserDate(this.beginTimeList[index].endtime) / 1000
        }
        var timestamp2 = Number(
            this.beginTimeList[index].begintime.split(' ')[0].replace(/-/g, '')
          ),
          timestamp3 = Number(
            dateStrFn(this.info.systime * 1000)
              .split(' ')[0]
              .replace(/-/g, '')
          )
        console.log(timestamp2, timestamp3)
        if (this.info.systime >= timestamp && this.info.systime < timestamp1) {
          console.log('index', index)
          i.push(index)
        } else if (timestamp2 > timestamp3) {
          i.push(-2)
        } else {
          i.push(-1)
        }
      })
      console.log('i', i)
      return i
    },
    isWap() {
      return getQueryString('pt') && getQueryString('pt') == 'app'
        ? 2
        : isWeixin()
        ? 1
        : 3
    }
  },
  data() {
    return {
      actindex: -1,
      actImgPath: '',
      currentdiscount: 0,
      oldtotalmoney: 0,
      discounmoney: 0,
      currentfullgiftmoney: 0,
      saletotalmoney: 0,
      showofferdetails: false,
      showaction: false,
      showsku: false,
      info: {},
      list: [],
      nowPage: 1,
      pagesize: 10,
      noDataText: '————\n客官，么有啦~\n————',
      listItem: {},
      itemIndex: null,
      maxNum: null,
      totalnum: 0,
      checked: true,
      showshare: false,
      beginTimeList: [],
      begintime: '',
      timemsg: '',
      shareinfo: {
        title: '爆款特惠低至2折，限时福利速领�',
        desc: '官方超级补贴福利来啦，爆款限时底价抢，每人1份，快来抢购吧~',
        img: basepath + '/static/images/ms.jpg',
        shareUrl: basepath + '/Wxmall/WeChat/share' + wxAjaxData
      },
      tobj: null,
      rule:
        '1.每款商品每位用户均有1次抢购机会\n' +
        '2.抢购商品属于官方补贴福利，非商品质量问题原则上不退不换；部分地区需补10元运费（新疆、西藏、海南、内蒙古）\n' +
        '3.抢购商品限时限量，请在规定时间进行抢购',
      minipath: '',
      isnewpersontask: 0,
      newpersonjump: ''
    }
  },
  mounted: function() {
    if (isWeixin()) {
      this.isShare = true
      var query = window.location.href,
        base = new Base64(),
        arg = goMini(),
        path = ''
      if (this.$route.query.shareOpenid && this.$route.query.pt != 'xcx') {
        query = query.indexOf('?') >= 0 ? query + '&' + arg : query + '?' + arg
        path = '/pages/wlink/main.html?x=' + base.encode(query)
        if (exclusiveidFn()) path += '&exclusiveid=' + exclusiveidFn()
        this.minipath = path + pointParams('&', path)
      }
    }
    // if (isWeixin()) this.isShare = true
    this.getData()
  },
  beforeRouteEnter(to, from, next) {
    let boolvalue = true
    if (to.query.pt === 'app' && to.query.oper === 'login') {
      boolvalue = false
    } else if (from.path === '/code') {
      boolvalue = false
    } else if (from.path === '/order') {
      boolvalue = false
    }
    if (boolvalue) {
      // 当前页面刷新不需要切换位置
      next()
    } else {
      next()
    }
  },
  methods: {
    productFn(item) {
      var arg = isApp()
      if (!isWeixin()) {
        if (arg == '') {
          if (
            this.waptoken.waptoken &&
            this.waptoken.waptoken == this.waptoken.tourists
          ) {
            this.$router.push({
              path: '/login',
              query: {
                routeval: 'msindex'
              }
            })
            return
          }
        }
      }
      window.location.href =
        '/static/wx/html/time-limit-actpage/timelimitproduct.html?limitid=' +
        item.limitid +
        '&exclusiveid=' +
        exclusiveidFn() +
        pointParams('&') +
        arg
    },
    newpersontask() {
      var arg = isApp()
      window.location =
        this.newpersonjump +
        (this.newpersonjump.indexOf('?') >= 0 ? arg : '?1=1' + arg)
    },
    parserDate: function(date) {
      if (typeof date !== 'string') {
        return date
      }
      var t = Date.parse(date.replace(/-/g, '/'))
      if (!isNaN(t)) {
        return new Date(Date.parse(date.replace(/-/g, '/')))
      } else {
        return new Date()
      }
    },
    finish: function(item, index) {
      if (item.actstatus == 0) {
        item.actstatus = 2
      } else if (item.actstatus == 1) {
        item.actstatus = 2
        item.time = (item.endtime - item.begintime) * 1000
      }
    },
    handleTime(n, i) {
      if (i == -1) return
      this.begintime = this.beginTimeList[i].begintime
      this.actindex = i
      this.getData()
    },
    getData() {
      // var base = new Base64()
      let url = this.$ajax.getLimitActIndex_URL,
        that = this,
        arg = isApp()
      if (this.begintime) {
        url += '?begintime=' + this.begintime
      }
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          this.info = res.data
          if (res.data.beginlist.length == 0) {
            this.$dialog
              .alert({
                title: '活动已结束',
                message: '快去看看其他活动吧！',
                className: 'percen_button_alert',
                confirmButtonColor: '#FFFCFC',
                confirmButtonText: '我知道了',
                closeOnPopstate: false
              })
              .then(function() {
                // on confirm
                that.homeClick()
              })
            return
          }
          if (res.data.shareinfo && res.data.shareinfo.sharetitle) {
            this.shareinfo.title = res.data.shareinfo.sharetitle
            this.shareinfo.desc = res.data.shareinfo.sharedesc
            this.shareinfo.img = res.data.shareinfo.shareimg
          }
          if (isWeixin() && arg == '') {
            fenxiang({
              title: encodeURIComponent(this.shareinfo.title),
              desc: encodeURIComponent(this.shareinfo.desc),
              imgx: this.shareinfo.img,
              type: 'msindex',
              dataStr: 'type=msindex',
              path: 'msindex',
              callback: function() {
                this.showshare = false
              }
            })
          }
          this.beginTimeList = res.data.beginlist.map((item) => {
            return {
              begintime: item.begintime,
              endtime: item.endtime,
              hour: item.hour,
              time: item.begintime.substr(item.begintime.indexOf(' ') + 1, 5)
            }
          })
          clearInterval(this.tobj)
          this.tobj = setInterval(() => {
            var timestamp = Date.parse(new Date()) / 1000
            var timestamp1 =
              this.parserDate(this.beginTimeList[0].endtime) / 1000
            console.log('time1', timestamp1)
            console.log('time', timestamp)
            if (timestamp1 < timestamp) {
              clearInterval(this.tobj)
              this.getData()
            }
          }, 60000)
          this.list = this.info.itemlist.map((item) => {
            item.time = this.timeFn(
              item.begintime,
              this.info.systime,
              item.endtime
            )
            return item
          })
        }
      })
      this.$newuserFn((data) => {
        if (data.code == 200) {
          this.isnewpersontask = data.isnewpersontask
          this.newpersonjump = data.newpersonjump ? data.newpersonjump : ''
        }
      })
    },
    timeFn: function(begintime, systime, endtime) {
      let btime = this.parserDate(begintime) / 1000,
        etime = this.parserDate(endtime) / 1000
      if (this.info.systime < btime) {
        return (btime - this.info.systime) * 1000
      } else if (systime >= btime && systime < etime) {
        return (etime - systime) * 1000
      }
    },
    share: function() {
      var arg = isApp()
      if (arg == '') {
        if (isWeixin()) {
          this.showshare = true
        } else {
          this.$toast('关注【创客村】公众号，惊喜享不停')
        }
      } else if (arg.indexOf('xcx') >= 0) {
        this.showshare = true
        var data = {
          type: 'msindex',
          title: encodeURIComponent(this.shareinfo.title),
          link: basepath + 'msindex?1=1' + arg,
          img: this.shareinfo.img
        }
        wx.miniProgram.postMessage({ data: data })
      } else {
        var obj = {
          type: 'shareFriends',
          title: encodeURIComponent(this.shareinfo.title),
          img: this.shareinfo.img,
          desc: encodeURIComponent(this.shareinfo.desc),
          link: encodeURIComponent(this.shareinfo.shareUrl + '&type=msindex')
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    },
    ruleFn: function() {
      this.$dialog
        .alert({
          title: '活动规则',
          message: this.rule,
          className: 'rule percen_button_alert integral_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(function() {
          // on confirm
        })
    },
    // productDetailsFn (items) {
    //   console.log(items)
    //   var arg = isApp()
    //   if (arg == '') {
    //     this.$router.push({
    //       path: '/msproduct',
    //       query: {
    //         itemid: items.limitid
    //       }
    //     })
    //   } else {
    //     this.$router.push('/msproduct?' + arg + '&itemid=' + items.limitid)
    //   }
    // },
    homeClick: function() {
      var arg = isApp()
      if (arg == '') {
        this.$router.replace('/')
      } else if (arg.indexOf('xcx') >= 0) {
        wx.miniProgram.reLaunch({
          url:
            '/pages/index/main?exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      } else {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goIndex'
          })
        )
      }
    }
  },
  filters: {
    salespricepositive(value) {
      return parseInt(value)
    },
    salespricedecimal(value) {
      let v = parseFloat(value).toFixed(2) + ''
      v = v.substring(v.indexOf('.') + 1)
      return v
    }
  }
  // watch: {
  //   checkAlled (val) {
  //     this.checked = val
  //   }
  // }
}
</script>

<style scoped lang="scss">
.container {
  background: #f38f47;

  .result_tit {
    position: absolute;
    top: 0.15rem;
    left: 0;
    width: 100%;

    img {
      width: 2.48rem;
      height: 0.52rem;
      margin: 0 auto;
    }
  }

  .result_instructions {
    background: url('../../assets/images/testresultbg.png') top center no-repeat;
    background-size: 100% 100%;
    margin: 0.18rem 0.1rem;
    padding: 0 0.16rem;
    padding-bottom: 0.49rem;

    .result_list_x {
      position: relative;
      min-height: 1.12rem;
      margin-top: 0.18rem;

      .header {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 0;

        img {
          width: 2.87rem;
          height: 0.4rem;
          margin: 0 auto;
        }
      }

      .con_d {
        position: absolute;
        top: 0.2rem;
        left: 0;
        width: 100%;
        font-size: 0.15rem;
        line-height: 0.21rem;
        color: #6c6967;
        background: #fef6e2;
        border-radius: 0.1rem;
        border: solid 1px #323232;
        padding: 0.24rem 0.16rem;
      }
    }

    .goprolist {
      margin-top: 1.55rem;
      font-size: 0.15rem;
      line-height: 0.21rem;
      color: #434343;
      font-weight: 400;
      display: flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      -o-align-items: center;
      justify-content: center;
      -webkit-justify-content: center;
      -moz-justify-content: center;
      -ms-justify-content: center;
      -o-justify-content: center;

      span {
        color: #000;
        width: 0.15rem;
        height: 0.15rem;
        display: block;
        background: url('../../assets/images/ndoright.png') no-repeat center;
        background-size: 80% 80%;
        margin-left: 0.02rem;
      }
    }

    .result_title {
      display: flex;
      justify-content: center;
      align-content: flex-start;
      font-size: 0.19rem;
      font-weight: 600;
      color: #434343;
      padding-top: 0.76rem;
      text-align: justify;

      div:nth-child(1),
      div:nth-child(3) {
        color: #7f776e;
        font-size: 0.27rem;
        line-height: 0.38rem;
      }

      div:nth-child(2) {
        margin-top: 0.1rem;
      }
    }

    .result_n1 {
      font-size: 0.13rem;
      margin-top: 0.08rem;
      text-align: center;
      color: #8e8e8d;
    }

    .result_n2_desc {
      margin-top: 0.18rem;
      font-size: 0.13rem;

      table td:nth-child(odd) {
        background: #fff2ea;
        text-align: center;
        vertical-align: middle;
      }

      table td:nth-child(even) {
        background: #e8eefc;
        text-align: center;
        vertical-align: middle;
      }

      .main_t {
        font-size: 0.16rem;
        line-height: 0.22rem;
      }

      .main_d {
        font-size: 0.11rem;
        color: #8e8e8d;
        line-height: 0.16rem;
      }

      .main_v {
        padding: 0.09rem 0;
      }
    }

    .result_test {
      margin-top: 0.19rem;

      img {
        width: 1.12rem;
        height: 0.44rem;
        margin: 0 auto;
      }
    }

    .result_skin_peculiarity {
      margin-top: 0.46rem;

      .header {
        .tit {
          img {
            width: 0.95rem;
            height: 0.36rem;
          }

          margin-bottom: 0.1rem;
        }

        border-bottom: solid 1px #939393;
      }

      .con {
        padding-top: 0.04rem;
        font-size: 0.13rem;
        line-height: 0.18rem;
        color: #8d8d8d;
      }
    }

    .result_testnursing {
      margin-top: 0.19rem;

      .header {
        .tit {
          img {
            width: 0.95rem;
            height: 0.36rem;
          }

          margin-bottom: 0.1rem;
        }

        border-bottom: solid 1px #939393;
      }

      .con {
        padding-top: 0.04rem;
        font-size: 0.13rem;
        line-height: 0.18rem;
        color: #8d8d8d;
      }
    }
  }

  .result_list {
    position: relative;

    .header {
      overflow: hidden;
      margin-bottom: 0.1rem;
      position: relative;
      /*position: absolute;*/
      /*top: 0;*/
      /*left: 0;*/
      width: 100%;
      z-index: 0;
      /*background: #FFE4CC;*/
      img {
        width: 100%;
        /*height: .74rem;*/
        /*margin: 0 auto;*/
      }

      .share {
        /*height: 0.6rem;*/
        font-size: 0;
        text-align: center;
        position: absolute;
        bottom: 0.26rem;
        left: 0;
        right: 0;

        .btn {
          margin: 0 auto;
          display: inline-block;
          min-width: 1.21rem;
          height: 0.33rem;
          color: #d25927;
          font-size: 0.13rem;
          background: linear-gradient(
            0deg,
            rgba(255, 216, 0, 1),
            rgba(246, 255, 0, 1)
          );
          background: -webkit-linear-gradient(
            0deg,
            rgba(255, 216, 0, 1),
            rgba(246, 255, 0, 1)
          );
          background: -moz-linear-gradient(
            0deg,
            rgba(255, 216, 0, 1),
            rgba(246, 255, 0, 1)
          );
          background: -ms-linear-gradient(
            0deg,
            rgba(255, 216, 0, 1),
            rgba(246, 255, 0, 1)
          );
          background: -o-linear-gradient(
            0deg,
            rgba(255, 216, 0, 1),
            rgba(246, 255, 0, 1)
          );
          border-radius: 0.2rem;
          line-height: 0.33rem;
          text-align: center;
        }
      }
      .rule {
        position: absolute;
        background: #a31a0c;
        color: #ffffff;
        padding: 0.04rem 0.05rem 0.04rem 0.08rem;
        border-radius: 0.2rem 0 0 0.2rem;
        right: 0;
        top: 0.5rem;
      }
    }
    .van-sticky--fixed .navlist {
      background: #f38f47;
      margin-bottom: 0;
      padding-top: 0.1rem;
      padding-bottom: 0.12rem;
    }

    .navlist {
      padding: 0 0.355rem 0.055rem;
      margin-bottom: 0.2rem;
      background: #f38f47;
      position: relative;
      .li {
        text-align: center;
        color: #fff;

        &.qgz {
          .time {
            color: #ffec3d;
          }

          .btn {
            background: #ffec3d;
            border-radius: 0.07rem;
            color: #f38f47;
            padding: 0 0.05rem;
          }
        }

        .time {
          font-size: 0.13rem;
          color: #fff;
          text-align: center;
        }

        .btn {
          font-size: 0.1rem;
          color: #fff;
          text-align: center;
        }

        &:first-of-type {
          img {
            width: 0.35rem;
            height: 0.35rem;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }

      &:after {
        content: '';
        display: block;
        height: 0.01rem;
        width: 100%;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -0.02rem;
        background: linear-gradient(
          90deg,
          #f38f47,
          rgba(255, 255, 255, 1),
          #f38f47
        );
        background: -webkit-linear-gradient(
          90deg,
          #f38f47,
          rgba(255, 255, 255, 1),
          #f38f47
        );
        background: -moz-linear-gradient(
          90deg,
          #f38f47,
          rgba(255, 255, 255, 1),
          #f38f47
        );
        background: -ms-linear-gradient(
          90deg,
          #f38f47,
          rgba(255, 255, 255, 1),
          #f38f47
        );
        background: -o-linear-gradient(
          90deg,
          #f38f47,
          rgba(255, 255, 255, 1),
          #f38f47
        );
      }
    }
    .nodata {
      font-size: 0.14rem;
      text-align: center;
      padding-top: 35%;
      color: #ffffff;
    }

    .list {
      /*position: absolute;*/
      /*top: .7rem;*/
      /*left: 0;*/
      width: 100%;
      z-index: 1;
      padding: 0 0.2rem;
      /*background: #FFE4CC;*/
      padding-bottom: 0.8rem;

      .itembg {
        /*background: url('../../assets/images/testskinplanitembg.png') center no-repeat;*/
        /*background-size: 100% 100%;*/
        position: relative;
        margin-top: 0.1rem;
        font-size: 0;
        .tag {
          display: inline-block;
          background: linear-gradient(
            90deg,
            rgba(61, 34, 178, 1),
            rgba(130, 24, 239, 1)
          );
          background: -webkit-linear-gradient(
            90deg,
            rgba(61, 34, 178, 1),
            rgba(130, 24, 239, 1)
          );
          background: -moz-linear-gradient(
            90deg,
            rgba(61, 34, 178, 1),
            rgba(130, 24, 239, 1)
          );
          background: -ms-linear-gradient(
            90deg,
            rgba(61, 34, 178, 1),
            rgba(130, 24, 239, 1)
          );
          background: -o-linear-gradient(
            90deg,
            rgba(61, 34, 178, 1),
            rgba(130, 24, 239, 1)
          );
          border-radius: 0.06rem;
          font-size: 0.1rem;
          padding: 0.03rem 0.11rem 0.04rem 0.05rem;
          .msg {
            color: #ffffff;
            display: flex;
            align-items: center;
            img {
              width: 0.08rem;
              height: 0.095rem;
              margin-right: 0.03rem;
            }
          }
        }

        .item {
          background: #fffeff;
          border-radius: 0.05rem;
          padding: 0.07rem;
          display: flex;
          display: -o-flex;
          display: -moz-flex;
          display: -ms-flex;
          display: -webkit-flex;
          align-items: center;
          -o-align-items: center;
          -moz-align-items: center;
          -ms-align-items: center;
          -webkit-align-items: center;
          margin-top: 0.1rem;
          position: relative;

          .proitem {
            display: flex;
            display: -o-flex;
            display: -moz-flex;
            display: -ms-flex;
            display: -webkit-flex;
            align-items: flex-start;
            -o-align-items: flex-start;
            -moz-align-items: flex-start;
            -ms-align-items: flex-start;
            -webkit-align-items: flex-start;
            flex: 1;
            -webkit-flex: 1;
            -o-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;

            .img {
              /*margin-left: .08rem;*/
              position: relative;
              img {
                width: 0.97rem;
                height: 0.97rem;
              }
              .soldout {
                position: absolute;
                width: 59%;
                height: 59%;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                margin: auto;
              }
            }

            .con {
              width: 100%;
              margin-left: 0.07rem;
              height: 0.85rem;
              position: relative;

              .tit {
                font-size: 0.13rem;
                color: #0a2589;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
                margin-top: 0.04rem;
              }

              .spec {
                font-size: 0.11rem;
                color: #6c6c6c;
                margin-top: 0.03rem;
                height: 0.19rem;

                .spec_con {
                  float: left;
                  background: #f6f6f6;
                  border-radius: 0.1rem;
                  padding: 0.01rem 0.07rem;
                  line-height: 0.16rem;
                  padding-bottom: 0.02rem;
                  display: flex;
                  align-content: center;
                  align-items: center;

                  .van-icon {
                    font-size: 0.09rem;
                    margin-left: 0.03rem;
                  }
                }
              }

              .supplement {
                color: #2c2c2c;
                font-size: 0.1rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
              }

              .totalinv {
                color: #5c5c5c;
                font-size: 0.1rem;
                margin-top: 0.05rem;
              }

              .priceAndnum {
                position: absolute;
                bottom: -0.11rem;
                left: 0;
                width: 100%;
                /*display: flex;*/
                /*justify-content: space-between;*/
                /*align-items: center;*/
                .pricebox {
                  margin-bottom: 0.05rem;
                  display: flex;
                  align-items: flex-end;
                }
                .price {
                  display: flex;
                  align-items: flex-end;
                  line-height: 0.09rem;
                  color: #e22a41;
                  font-size: 0.16rem;

                  .fh {
                    font-size: 0.09rem;
                    line-height: 0.09rem;
                  }

                  .positive {
                    font-size: 0.16rem;
                    font-weight: 600;
                    line-height: 0.12rem;
                  }

                  .dian {
                    font-size: 0.15rem;
                    line-height: 0.13rem;
                  }

                  .decimal {
                    font-size: 0.13rem;
                    line-height: 0.13rem;
                  }
                }
                .gray {
                  color: #6c6c6c;
                  margin-left: 0.05rem;
                  line-height: 0.09rem;
                  .positive {
                    font-size: 0.12rem;
                    font-weight: 400;
                    line-height: 0.09rem;
                    text-decoration: line-through;
                  }
                }
                .cdown {
                  font-size: 14px;
                  margin-top: 10px;
                }

                .progress {
                  margin-top: 0.09rem;
                  width: 70%;
                  height: 0.18rem;
                  position: relative;

                  .num {
                    color: #5c5c5c;
                    font-size: 0.07rem;
                    position: absolute;
                    left: 101%;
                    top: -0.02rem;
                  }

                  .bought {
                    font-size: 0.07rem;
                    color: #5c5c5c;
                  }
                }
                .text {
                  color: #fc1d3b;
                  font-size: 0.1rem;
                }
                .colon {
                  margin-right: 0;
                }
                .time {
                  color: #ffffff;
                  background: #fc1d3b;
                  padding: 0 0.02rem;
                  text-align: center;
                  min-width: 0.16rem;
                  border-radius: 0.02rem;
                  font-size: 0.1rem;
                }
              }
              .dialog1 {
                position: absolute;
                right: 0;
                top: 57%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                font-size: 0.11rem;
                color: #fff;
                background: #777;
                border-radius: 0.03rem;
                min-width: 0.64rem;
                height: 0.23rem;
                line-height: 0.23rem;
                text-align: center;
              }
              .dialog {
                position: absolute;
                right: 0;
                top: 70%;
                transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                -moz-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                font-size: 0.11rem;
                color: #fff;
                background: linear-gradient(
                  90deg,
                  rgba(255, 20, 74, 1),
                  rgba(242, 60, 10, 1)
                );
                background: -webkit-linear-gradient(
                  90deg,
                  rgba(255, 20, 74, 1),
                  rgba(242, 60, 10, 1)
                );
                background: -o-linear-gradient(
                  90deg,
                  rgba(255, 20, 74, 1),
                  rgba(242, 60, 10, 1)
                );
                background: -moz-linear-gradient(
                  90deg,
                  rgba(255, 20, 74, 1),
                  rgba(242, 60, 10, 1)
                );
                background: -ms-linear-gradient(
                  90deg,
                  rgba(255, 20, 74, 1),
                  rgba(242, 60, 10, 1)
                );
                border-radius: 0.03rem;
                min-width: 0.64rem;
                height: 0.23rem;
                line-height: 0.23rem;
                text-align: center;
              }
            }
          }
          .disabled {
            background: rgba(0, 0, 0, 0.25);
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 0.05rem;
          }
        }

        .act_desc_tag {
          font-size: 0.12rem;
          margin-top: 0.08rem;
          margin-left: 0.28rem;

          .van-icon-arrow {
            float: right;
          }
        }

        .act_desc_time {
          font-size: 0.11rem;
          margin-left: 0.28rem;
          color: #f12a0e;
          margin-top: 0.04rem;
          display: flex;
          align-items: center;

          img {
            width: 0.12rem;
          }

          .txt {
            font-size: 0.12rem;
            color: #f12a0e;
            transform: scale(0.92, 0.92);
            margin-left: -0.03rem;
            line-height: 0.17rem;
          }
        }

        .act_desc_time .van-icon-warning-o {
          float: left;
          font-size: 0.16rem;
          display: block;
          margin-right: 0.04rem;
        }

        .act_desc {
          font-size: 0.12rem;
          transform: scale(0.8);
          margin-top: 0.04rem;
          color: #fc0324;
        }
      }
    }
  }

  .offer.van-popup--bottom {
    bottom: 0.44rem;
  }

  .offerdetailsdis {
    .ofd1 {
      font-size: 0.12rem;
      color: #3d3d3d;
      text-align: center;
      line-height: 0.17rem;
      margin-top: 0.18rem;
      margin-bottom: 0.2rem;
    }
    .list {
      padding: 0.15rem;

      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.14rem;
        padding-bottom: 0.12rem;
        color: #242424;
        line-height: 0.2rem;
        font-weight: 400;
      }

      .goodstotalprice {
        color: #242424;
        font-weight: 600;
      }

      .combined {
        font-size: 0.16rem;
        color: #fc0324;
        line-height: 0.22rem;
        font-weight: 400;
      }

      .desc {
        color: #3d3d3d;
        font-size: 0.12rem;
        line-height: 0.17rem;
        padding-bottom: 0.3rem;
      }
    }
  }

  .van-action-sheet__close {
    background: url('../../assets/images/closex.png') center no-repeat;
    background-size: 0.2rem 0.2rem;
  }

  .van-action_model {
    height: 70vh;

    .van-item {
      padding: 0.14rem;

      .tit {
        font-size: 0.14rem;
        color: #262626;
        font-weight: 400;
        line-height: 0.23rem;
      }

      .con {
        padding-top: 0.1rem;
        line-height: 0.23rem;
        font-size: 0.13rem;
        color: #333333;
      }
    }

    .btn {
      padding: 0.14rem;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;

      .vanbtn {
        width: 100%;
        height: 0.43rem;
        background: linear-gradient(
          90deg,
          rgba(252, 3, 36, 1) 0%,
          rgba(246, 58, 102, 1) 100%
        );
        border-radius: 0.25rem;
      }
    }
  }

  .presale_info_dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3001;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -o-align-items: center;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);

    .dialog {
      width: 79%;
      margin: 0 auto;
      background: #fff;
      border-radius: 0.04rem;
      height: 2.24rem;
      position: relative;

      .header1 {
        width: 70%;
        margin: 0 auto;
        font-weight: bold;

        .van-divider {
          display: -webkit-box;
          display: -webkit-flex;
          display: flex;
          -webkit-box-align: center;
          -webkit-align-items: center;
          align-items: center;
          margin: 0.2rem 0;
          line-height: 0.24rem;
          border-color: #666666;
          border-style: solid;
          border-width: 0;
          color: #333333;
          font-size: 0.21rem;
        }

        .van-divider::before,
        .van-divider::after {
          content: ' ';
          display: block;
          -webkit-box-flex: 1;
          -webkit-flex: 1;
          flex: 1;
          box-sizing: border-box;
          height: 1px;
          border-color: inherit;
          border-style: inherit;
          border-width: 0 0 0;
          margin-right: 0.16rem;
          margin-left: 0.16rem;
        }
      }

      .content {
        width: 80%;
        margin: 0 auto;
        text-align: center;
        color: #444444;
        font-size: 0.14rem;
        margin-top: 0.02rem;
        line-height: 0.2rem;
        height: 1.2rem;
        overflow-y: auto;
      }

      .btn {
        background: #fc0324;
        width: 50%;
        text-align: center;
        color: #fff;
        font-size: 0.15rem;
        border-radius: 0.16rem;
        height: 0.31rem;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 25%;
        bottom: 0.22rem;
      }
    }
  }

  .additemMsg {
    position: fixed;
    left: 0;
    bottom: 0.52rem;
    width: 100%;
    padding: 0.15rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    z-index: 10;

    .msg {
      font-size: 0.12rem;
      line-height: 0.14rem;
      color: #333333;
      display: flex;
      align-items: center;

      img {
        width: 0.13rem;
        margin-right: 0.06rem;
      }
    }

    .btn {
      font-size: 0.12rem;
      color: #ff253e;
      white-space: nowrap;
      margin-left: 0.08rem;
    }
  }

  .sharecontainer {
    position: fixed;
    width: 100%;
    z-index: 100;
    height: 100%;
    left: 0;
    top: 0;

    img {
      position: absolute;
      top: 0;
      right: 0.35rem;
      width: 1.53rem;
    }

    .know {
      width: 1.09rem;
      height: 0.36rem;
      line-height: 0.36rem;
      color: #fff;
      border-color: #fff;
      background: transparent;
      position: absolute;
      bottom: 1.5rem;
      left: 50%;
      margin-left: -0.54rem;
    }
  }

  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.1rem;
    bottom: 0.6rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;

    img {
      width: 0.4rem;
      height: 0.4rem;
      display: block;
    }
  }
}
</style>

<style lang="scss">
.container {
  .good_sku .van-sku-row__item {
    border-radius: 0.15rem;
    font-size: 0.13rem;
    color: #5e5e5e;
    padding: 0 0.1rem;
    border: solid 1px transparent;
  }

  .good_sku .van-sku-row__item::before {
    background: #eeeff4;
  }

  .good_sku .van-sku__goods-price {
    margin-top: 0.2rem;
  }

  .good_sku .van-sku__price-symbol,
  .van-sku__price-num {
    font-size: 0.16rem;
    color: #fc0324;
    font-weight: 600;
  }

  .good_sku .van-sku-row__item--active {
    border: solid 1px #fc0324;
    background-color: #fcedeb;
    color: #fc0324;
  }

  .good_sku .van-sku-row__item-name {
    padding: 0.06rem;
  }

  .good_sku .van-sku-row__item-img {
    width: 0.2rem;
    height: 0.2rem;
  }

  .good_sku.van-popup--bottom.van-popup--round {
    border-radius: 0;
  }

  .good_sku .van-sku-row__title,
  .van-sku__stepper-title {
    padding-bottom: 0.13rem;
    font-size: 0.13rem;
    color: #333333;
    line-height: 0.18rem;
    font-weight: 600;
  }

  .good_sku .van-sku__stepper {
    border-radius: 0.13rem;
    overflow: hidden;
  }

  .good_sku .van-stepper__minus,
  .van-stepper__plus,
  .van-stepper__input {
    height: 0.22rem;
  }

  .good_sku .van-stepper__minus::before,
  .van-stepper__plus::before {
    width: 9px;
  }

  .good_sku .van-stepper__minus::after,
  .van-stepper__plus::after {
    height: 9px;
  }

  .good_sku .van-sku-row__item--disabled {
    background: #fcfcfc;
    border-radius: 0.15rem;
    border: 1px solid #eeeff4;
    color: #dedede;

    &:before {
      background: #fcfcfc;
    }
  }

  .pro_details_con {
    font-size: 0.14rem;
  }

  .pro_details_con img {
    width: 100% !important;
    height: auto !important;
  }

  .pro_details_con .ckeditor-html5-video {
    width: 100%;
  }

  .pro_details_con .ckeditor-html5-video video {
    width: 100%;
  }
}

.mscontainer {
  .van-progress__pivot {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/38actpage/msindex.vue